import React, { useEffect, useState } from 'react';
import { readCachedIsRu, fetchIsRu } from '../../api/geo';
import './SocialLinks.scss';

interface SocialLink {
  id: string;
  label: string;
  href: string;
  icon: React.ReactNode;
}

const VkIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93v6.14C2 20.67 3.33 22 8.93 22h6.14C20.67 22 22 20.67 22 15.07V8.93C22 3.33 20.67 2 15.07 2zm3.08 13.37h-1.66c-.63 0-.82-.5-1.94-1.63-1-.96-1.4-.96-1.64-.96-.33 0-.43.1-.43.56v1.5c0 .4-.13.64-1.18.64-1.74 0-3.66-1.05-5.02-3.02C4.7 10.11 4.2 8.16 4.2 7.74c0-.24.1-.46.56-.46h1.66c.42 0 .58.18.74.63.82 2.36 2.19 4.43 2.76 4.43.21 0 .31-.1.31-.65V9.53c-.07-1.18-.69-1.28-.69-1.7 0-.21.17-.42.45-.42h2.6c.36 0 .49.19.49.6v3.23c0 .36.16.49.27.49.21 0 .38-.13.76-.51 1.17-1.32 2.01-3.34 2.01-3.34.1-.24.31-.46.73-.46h1.66c.5 0 .61.26.5.6-.21.97-2.24 3.84-2.24 3.84-.18.29-.24.42 0 .74.17.24.74.74 1.12 1.19.7.79 1.23 1.45 1.37 1.91.14.45-.08.68-.54.68z"/>
  </svg>
);

const RutubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 13.5v-7l5.5 3.5-5.5 3.5z"/>
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34l-.02-8.43a8.27 8.27 0 0 0 4.84 1.55V5.01a4.85 4.85 0 0 1-1.05-.32z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
);

export const SOCIAL_LINKS_CONFIG: { id: string; label: string; envHref: string | undefined; icon: React.ReactNode }[] = [
  { id: 'vk',        label: 'ВКонтакте', envHref: process.env.REACT_APP_SOCIAL_VK,        icon: <VkIcon /> },
  { id: 'rutube',    label: 'Rutube',    envHref: process.env.REACT_APP_SOCIAL_RUTUBE,    icon: <RutubeIcon /> },
  { id: 'telegram',  label: 'Telegram',  envHref: process.env.REACT_APP_SOCIAL_TELEGRAM,  icon: <TelegramIcon /> },
  { id: 'youtube',   label: 'YouTube',   envHref: process.env.REACT_APP_SOCIAL_YOUTUBE,   icon: <YouTubeIcon /> },
  { id: 'tiktok',    label: 'TikTok',    envHref: process.env.REACT_APP_SOCIAL_TIKTOK,    icon: <TikTokIcon /> },
  { id: 'instagram', label: 'Instagram', envHref: process.env.REACT_APP_SOCIAL_INSTAGRAM, icon: <InstagramIcon /> },
];

const LINKS: SocialLink[] = SOCIAL_LINKS_CONFIG
  .filter((l): l is SocialLink & { envHref: string } => Boolean(l.envHref && l.envHref.trim()))
  .map(({ id, label, envHref, icon }) => ({ id, label, href: envHref.trim(), icon }));

// Blocked or restricted in Russia — never shown to a client resolved as RU.
// While the answer is unknown (first visit, geo request in flight or failed)
// these stay hidden too: appearing late for everyone else beats flashing a
// link at the audience it must not be shown to.
const RU_HIDDEN = new Set(['telegram', 'youtube', 'instagram']);

export const SocialLinks: React.FC = () => {
  const [isRu, setIsRu] = useState<boolean | null>(readCachedIsRu);
  useEffect(() => {
    fetchIsRu().then(setIsRu).catch(() => {});
  }, []);

  const links = isRu === false ? LINKS : LINKS.filter(l => !RU_HIDDEN.has(l.id));
  if (links.length === 0) return null;
  return (
    <div className="social-links">
      {links.map(({ id, label, href, icon }) => (
        <a
          key={id}
          className={`social-links__btn social-links__btn--${id}`}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          title={label}
        >
          {icon}
        </a>
      ))}
    </div>
  );
};
